// MUI
import { Grid, Typography } from "@mui/material";

// Components
import TimeLineHistory from "./TimeLineGraph/index";

// Types
import { ITimelineNode } from "@PayPlans/types/historical.ts";

type TimeLineHistoryHeaderProps = {
	nodeTimeLineList: ITimelineNode[];
	selectedIndex: number;
	setSelectedIndexParent: (index: number) => void;
};
export default function TimeLineHistoryHeader(props: TimeLineHistoryHeaderProps) {
	const { nodeTimeLineList, selectedIndex, setSelectedIndexParent } = props;

	return (
		<Grid container direction="row" className="h-96">
			<Typography className="group-pay-plan-assign-container-title">Timeline</Typography>
			<TimeLineHistory
				nodeTimeLineList={nodeTimeLineList}
				selectedIndex={selectedIndex}
				setSelectedIndexParent={setSelectedIndexParent}
			/>
		</Grid>
	);
}
